import React from "react"

import { Divider as AntDivider } from "antd"

const Divider = ({ space, type, ...props }) => {
  return <AntDivider style={{ margin: `${space}px 0` }} type={type} {...props} />
}

export default Divider
